"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [{
          'key': 'active',
          'name': '活跃用户'
        }, {
          'key': 'register',
          'name': '新增用户'
        }];
      }
    },
    chartType: {
      type: String,
      default: 'active'
    }
  },
  data: function data() {
    return {
      selectedType: this.chartType
    };
  },
  methods: {
    onChange: function onChange(val) {
      this.$emit('change', val);
    }
  }
};
exports.default = _default2;